module.exports = __webpack_public_path__ + "images/the-hobbyist-a739524be9d474fc9f486d6aa82da766.png";